import type { RawRuleOf } from '@casl/ability';
import type { CompanySettingsAccessContext } from '@/abilities/companySettings/context';
import type { CompanySettingsAbility } from '@/abilities/companySettings/vocabulary';
import { companySettingsGeneralRules } from '@/abilities/companySettings/rules/general';
import { companySettingsUsersRules } from '@/abilities/companySettings/rules/users';
import { companySettingsIntegrationsRules } from '@/abilities/companySettings/rules/integrations';
import { companySettingsApplicationsRules } from '@/abilities/companySettings/rules/applications';
import { companySettingsVendorPreferencesRules } from '@/abilities/companySettings/rules/vendorPreferences';
import { companySettingsApprovalsRules } from '@/abilities/companySettings/rules/approvals';
import { companySettingsBankFeedRules } from '@/abilities/companySettings/rules/bankFeed';

// Rules only on the destinations with nothing under them; a tab with sections and the settings screen take their access
// from their children (`treeDestinationAccess`).
export const companySettingsRules = (ctx: CompanySettingsAccessContext): RawRuleOf<CompanySettingsAbility>[] => [
  ...companySettingsGeneralRules(ctx),
  ...companySettingsUsersRules(ctx),
  ...companySettingsIntegrationsRules(ctx),
  ...companySettingsApplicationsRules(ctx),
  ...companySettingsVendorPreferencesRules(ctx),
  ...companySettingsApprovalsRules(ctx),
  ...companySettingsBankFeedRules(ctx),
];
